
import React      from 'react';
import PropTypes  from 'prop-types';
import BackButton from '../utils/back-button';
import { builderDispatch, PrismUI } from "../../_utils/ui";

class ServiceHeader extends React.Component {
  constructor(props) {
    super();
    this.onBackClick = props.onBackClick;
    this.title = props.title;
  }

  componentDidMount() {
    builderDispatch.dispatch({
      type: PrismUI.CLOUD_SERVICE_HEADER,
      mounted: true
    });
  }

  componentWillUnmount() {
    builderDispatch.dispatch({
      type: PrismUI.CLOUD_SERVICE_HEADER,
      mounted: false
    });
  }

  render() {
    return(<div className="modal-header justify-content-center align-items-center fixed-top border-0 service-header">
      <BackButton onBackClick={this.onBackClick} />
      <div className="header-title">
        <span className="text-truncate">{this.title}</span>
      </div>
    </div>);
  }
}

ServiceHeader.propTypes = {
  onBackClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default ServiceHeader;
